module.exports = __webpack_public_path__ + "img/skyscanner_logo.027a44a2.png";